(function () {
  function placeClanProductsLateInArticle() {
    var articleContent = document.querySelector('.blog-post-content rte-formatter');
    var productSection = document.querySelector('[id^="ClanBlogProducts-"]');
    if (!articleContent || !productSection) return;
    if (productSection.dataset.isSurname !== 'true') return;

    var totalText = (articleContent.innerText || articleContent.textContent || '').trim().length;
    if (totalText < 500) return;

    function ratioBefore(element) {
      try {
        var range = document.createRange();
        range.selectNodeContents(articleContent);
        range.setEndBefore(element);
        return range.toString().trim().length / totalText;
      } catch (e) {
        return null;
      }
    }

    function containsPromotion(element) {
      if (!element) return false;
      var links = Array.prototype.slice.call(element.querySelectorAll ? element.querySelectorAll('a[href]') : []);
      if (links.some(function (link) {
        var href = (link.getAttribute('href') || '').toLowerCase();
        return href.indexOf('/products/') !== -1 || href.indexOf('/collections/') !== -1 || href.indexOf('/search') !== -1;
      })) return true;
      var text = (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return /\b(shop|browse|view all|see all)\b/.test(text) && /\b(gift|gifts|collection|product|products)\b/.test(text);
    }

    function headingText(element) {
      return (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function isFaqHeading(element) {
      return /\b(faqs?|frequently asked questions?|common questions?)\b/.test(headingText(element));
    }

    function isExcludedBoundary(element) {
      return /\b(sources?|references?|related articles?|further reading|bibliography)\b/.test(headingText(element));
    }

    function isCleanBoundary(element) {
      var previous = element.previousElementSibling;
      var next = element.nextElementSibling;
      return !containsPromotion(element) && !containsPromotion(previous) && !containsPromotion(next);
    }

    var candidates = Array.prototype.slice.call(articleContent.querySelectorAll('h2')).map(function (element) {
      var ratio = ratioBefore(element);
      if (ratio === null || ratio < 0.70 || ratio > 0.90) return null;
      if (isExcludedBoundary(element) || !isCleanBoundary(element)) return null;
      return {
        element: element,
        ratio: ratio,
        faq: isFaqHeading(element),
        score: Math.abs(ratio - 0.80)
      };
    }).filter(Boolean);

    if (!candidates.length) return;

    var faqCandidates = candidates.filter(function (candidate) { return candidate.faq; });
    var pool = faqCandidates.length ? faqCandidates : candidates;
    pool.sort(function (a, b) { return a.score - b.score; });
    var chosen = pool[0];

    chosen.element.parentNode.insertBefore(productSection, chosen.element);
    productSection.classList.add('cbp--in-article');
    productSection.dataset.articlePlacementRatio = chosen.ratio.toFixed(3);
    productSection.dataset.articlePlacementMode = chosen.faq ? 'faq-before' : 'heading-before';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeClanProductsLateInArticle, { once: true });
  } else {
    placeClanProductsLateInArticle();
  }
})();
